import types from 'actions/types'
import {combineReducers} from 'redux'
import {get} from 'lodash'

export const selectedProductionDepartmentId = (state = null, action) => {
  switch (action.type) {
    case types.PRODUCTION_SELECT_PRODUCTION_DEPARTMENT:
      return get(action, 'id', null)
    default:
      return state
  }
}

export default combineReducers({
  selectedProductionDepartmentId,
})
